"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var LeftMenu_1 = require("./LeftMenu");
var Logo_1 = require("./Logo");
var RightMenu_1 = require("./RightMenu");
var createNarrowHeader_1 = __importDefault(require("./createNarrowHeader"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var defaultPages = ['promotions', 'payments', 'tournaments', 'vip'];
var Header = function (_a) {
    var isNotFoundPage = _a.isNotFoundPage, languages = _a.languages, _b = _a.pages, pages = _b === void 0 ? defaultPages : _b, withReferral = _a.withReferral, promoLink = _a.promoLink, textVariant = _a.textVariant, changeLanguageVariant = _a.changeLanguageVariant, _c = _a.isHavePadding, isHavePadding = _c === void 0 ? false : _c;
    var pathname = (0, navigation_1.usePathname)();
    var _d = (0, react_1.useState)(false), isNarrowXl = _d[0], setNarrowXl = _d[1];
    var _e = (0, react_1.useState)(null), narrowHeader = _e[0], setNarrowHeader = _e[1];
    var headerRef = (0, react_1.useRef)(null);
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    (0, react_1.useEffect)(function () {
        if (breakpoints.xl)
            setNarrowHeader((0, createNarrowHeader_1.default)(headerRef, setNarrowXl));
    }, [breakpoints.xl]);
    (0, react_1.useEffect)(function () {
        if (narrowHeader)
            narrowHeader.subscribeNarrowHeader();
        return function () { return narrowHeader && narrowHeader.removeNarrowHeader(); };
    }, [narrowHeader]);
    (0, react_1.useEffect)(function () {
        if (headerRef.current && isHavePadding) {
            document.body.style.marginTop = headerRef.current.clientHeight + 'px';
        }
    }, [isHavePadding]);
    if (pathname.includes('game-not-available')) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { id: "header", className: styles_module_scss_1.default.header, ref: headerRef },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
                    react_1.default.createElement(LeftMenu_1.LeftMenu, { isNotFoundPage: isNotFoundPage, pages: pages, promoLink: promoLink }),
                    react_1.default.createElement(Logo_1.Logo, null),
                    react_1.default.createElement(RightMenu_1.RightMenu, { isNarrowXl: isNarrowXl, isNotFoundPage: isNotFoundPage, languages: languages, withReferral: withReferral, textVariant: textVariant, changeLanguageVariant: changeLanguageVariant }))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.mask }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.darkBackground }))));
};
exports.default = Header;
